import {Component, input, output} from '@angular/core';
import {MatCardModule} from "@angular/material/card";
import {TranslateModule} from "@ngx-translate/core";
import {NgOptimizedImage} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'app-small-card',
  standalone: true,
  imports: [MatCardModule, MatIconModule, NgOptimizedImage, TranslateModule],
  templateUrl: './small-card.component.html',
  styleUrl: './small-card.component.sass'
})
export class SmallCardComponent {
  readonly title = input<string>('');
  readonly icon = input<string>('shopping_cart');
  readonly imageSrc = input<string>('img/istra/logo.png');
  readonly url = input<string>();

  readonly cardClick = output<void>();

  handleClick(): void {
    window.open(this.url(), '_blank', 'noopener');
  }
}
